import { useEffect, useState } from "react";
import { TeamForm } from "../../../components/team-form";
import { useTeam } from "../../../context/TeamContext";
import { TeamWithDetails } from "../../../types/team.types";
import { getObjectDiff } from "../../../utils/object-diff.utils";
import { InstitutionsProvider } from "../../../context/InstitutionsContext";
import { useNavigate } from "react-router-dom";

export interface ITeamInfoEditProps {
  team: TeamWithDetails;
  onCancel: () => void;
}

export default function TeamInfoEdit({ team, onCancel }: ITeamInfoEditProps) {
  const { updateTeam, getTeam } = useTeam(); 
  const [originalFormData, setOriginalFormData] = useState(team);
  const [modifiedFormData, setModifiedFormData] = useState(team);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setOriginalFormData(team);
    setModifiedFormData(team);
  }, [team]);

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value } = e.target as HTMLInputElement;
    setModifiedFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const changes = getObjectDiff(originalFormData, modifiedFormData);
      const { id, ...changesWithoutId } = changes;
      await updateTeam(changesWithoutId);
      getTeam();
      navigate("#");
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <InstitutionsProvider>
      <TeamForm
        buttonText="Guardar"
        team={{
          name: modifiedFormData.name,
          institution_id: modifiedFormData.institution?.id,
        }}
        handleChange={handleChange}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        onCancel={onCancel}
        onRequestNewInstitution={() => navigate("/dashboard/request-institution")}
      />
    </InstitutionsProvider>
  );
}
